var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4900C",
    d: "M36 26a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V6.313C4 4.104 9.791 0 12 0h18.625C33.719 0 36 2.312 36 5.375V26z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD6DD",
    d: "M34 30a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V6c0-4.119-.021-4 5-4h19a4 4 0 0 1 4 4v24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E8ED",
    d: "M32 31a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h22a3 3 0 0 1 3 3v24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M32 32a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4h19a4 4 0 0 1 4 4v22z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC4D",
    d: "M30 32a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4h17.335C28.544 8 30 9.456 30 11.665V32z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4900C",
    d: "M9 6C7.312 6 7.269 4.078 8 3.25C8.832 2.309 10.125 2 12.438 2H14V0h-2.719C7.312 0 4 2.5 4 5.375V32a4 4 0 0 0 4 4h2V6H9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M8.542 32.979c0 .702-.667 1.271-1.49 1.271c-.822 0-1.489-.569-1.489-1.271c0-.701.667-1.271 1.489-1.271c.823 0 1.49.569 1.49 1.271z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#66757F",
    d: "M6.894 32.271c-.48.055-.792.375-1.017.729c-.307.485-1.007 1-1.877 1c-1.104 0-2-.671-2-1.5S2.896 31 4 31v-1.996C1.833 29.025.083 30.579.083 32.5c0 1.934 1.772 3.5 3.958 3.5c1.854 0 3.347-1.045 3.901-2.569c.277-.759-.469-1.224-1.048-1.16z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M8.542 24.979c0 .702-.667 1.271-1.49 1.271c-.822 0-1.489-.569-1.489-1.271c0-.701.667-1.271 1.489-1.271c.823 0 1.49.569 1.49 1.271z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#66757F",
    d: "M6.894 24.271c-.48.055-.792.375-1.017.729c-.307.485-1.007 1-1.877 1c-1.104 0-2-.671-2-1.5S2.896 23 4 23v-1.996C1.833 21.025.083 22.579.083 24.5c0 1.934 1.772 3.5 3.958 3.5c1.854 0 3.347-1.045 3.901-2.569c.277-.759-.469-1.224-1.048-1.16z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M8.542 16.979c0 .702-.667 1.271-1.49 1.271c-.822 0-1.489-.569-1.489-1.271c0-.701.667-1.271 1.489-1.271c.823 0 1.49.569 1.49 1.271z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#66757F",
    d: "M6.894 16.271c-.48.055-.792.375-1.017.729c-.307.485-1.007 1-1.877 1c-1.104 0-2-.671-2-1.5S2.896 15 4 15v-1.996C1.833 13.025.083 14.579.083 16.5c0 1.934 1.772 3.5 3.958 3.5c1.854 0 3.347-1.045 3.901-2.569c.277-.759-.469-1.224-1.048-1.16z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M8.542 8.979c0 .702-.667 1.271-1.49 1.271c-.822 0-1.489-.569-1.489-1.271c0-.701.667-1.271 1.489-1.271c.823 0 1.49.569 1.49 1.271z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#66757F",
    d: "M6.894 8.271c-.48.055-.792.375-1.017.729C5.57 9.485 4.87 10 4 10c-1.104 0-2-.671-2-1.5S2.896 7 4 7V5.004C1.834 5.024.083 6.579.083 8.5c0 1.934 1.772 3.5 3.958 3.5c1.854 0 3.347-1.045 3.901-2.569c.277-.759-.469-1.224-1.048-1.16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashBook);
export default __webpack_public_path__ + "static/media/cashBook.f798b60855a45220c909a8c776b97792.svg";
export { ForwardRef as ReactComponent };